import { put, select } from 'redux-saga/effects';
import { AUTOMATION_SOURCE } from 'utils/constants';
import { selectFormById } from '../../formControlSelectors';
import { formControlActions } from '../../formControlSlice';
import { getFieldValueWithFallback, getRawFieldValue } from '../../lib/copyToFormHelpers';

export function* copySheetAnnouncementHandler({ payload: { transactionId, announcementValues, status = 'SUCCESS', color = null } }) {
    const form = yield select(selectFormById(transactionId));
    if (!form) return;

    const fields = form?.formConfig?.fields || [];
    const sheetAnnouncementValues = {};
    const fieldWrites = [];

    for (const { dataField: fieldName, lookup, editable, referenceField } of fields) {
        if (!editable) continue;

        const rawValue = getRawFieldValue(announcementValues, fieldName);
        if (rawValue === null || rawValue === undefined || rawValue === '' || typeof rawValue === 'object') continue;

        let newFieldValue = rawValue;
        if (lookup) {
            const lookupValue = getFieldValueWithFallback(announcementValues, fieldName, lookup, true);
            if (lookupValue) newFieldValue = lookupValue;
        }

        const displayValue = getFieldValueWithFallback(announcementValues, fieldName, lookup, false) || rawValue;
        fieldWrites.push({ fieldName, referenceField, newFieldValue, displayValue });
    }

    // The newest selection: a row copy still loading must not land over the fields this announcement
    // writes. One that fills nothing leaves it alone.
    if (fieldWrites.length) yield put(formControlActions.cancelCopies({ formId: transactionId }));

    for (const { fieldName, referenceField, newFieldValue, displayValue } of fieldWrites) {
        yield put(formControlActions.clearUserEdited({ formId: transactionId, fieldName }));

        if (referenceField) {
            yield put(formControlActions.setFieldValue({ formId: transactionId, fieldName: referenceField, value: null }));
        }

        yield put(formControlActions.setFieldValue({ formId: transactionId, fieldName, value: newFieldValue }));
        yield put(formControlActions.setFieldValueSource({ formId: transactionId, fieldName, source: AUTOMATION_SOURCE.SHEET_ANNOUNCEMENT }));
        yield put(formControlActions.setFieldError({ formId: transactionId, fieldName, error: false }));

        sheetAnnouncementValues[fieldName] = { value: displayValue, status, color };
    }

    if (Object.keys(sheetAnnouncementValues).length > 0) {
        yield put(formControlActions.setSheetAnnouncementValues({ formId: transactionId, sheetAnnouncementValues }));
    }
}
